import { Alert, Box, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import isEmail from 'validator/lib/isEmail';
import { initiateSso } from './api';
import { SubmitButton } from './SubmitButton';
import { MAX_EMAIL } from './fieldLimits';
import { autofillSx } from './fieldStyles';
import { useFormSubmit } from './useFormSubmit';

export const SsoOptions = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const { loading, error, setError, runSubmit } = useFormSubmit();

  /** Same check as LocalLoginForm — see the note there; this form is `noValidate` too. */
  const isEmailInvalid = email.length > 0 && !isEmail(email);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isEmailInvalid) return;
    await runSubmit(async () => {
      const { url } = await initiateSso(email);
      globalThis.location.href = url;
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      <Stack spacing={2.5}>
        <Typography variant="body2" color="text.secondary">
          {t('login.sso.description')}
        </Typography>

        {error && (
          <Alert severity="error" onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        <TextField
          label={t('formField.Email')}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
          fullWidth
          size="small"
          autoComplete="email"
          error={isEmailInvalid}
          helperText={isEmailInvalid ? t('login.local.invalidEmail') : undefined}
          inputProps={{ maxLength: MAX_EMAIL }}
          sx={autofillSx}
        />

        <SubmitButton loading={loading} disabled={!email || isEmailInvalid}>
          {t('login.sso.continue')}
        </SubmitButton>
      </Stack>
    </Box>
  );
};
